<span>
    {{ formattedDateTime() }} 
</span>